// removed by extract-text-webpack-plugin
module.exports = {"price":"_3sRXEQ2Cv9t4eCIejEICYg","priceTitle":"_1zw6OY6xiunYX1dQ7k17kA"};


/*****************
 ** WEBPACK FOOTER
 ** ./client/act/PriceField.css
 ** module id = 949
 ** module chunks = 1
 **/